import React, { FC, createRef, RefObject, ReactNode, useEffect } from 'react';
import TaskDetailsBodyLayout from '@ui-components/task-details-body-layout';
import TaskDetailsNameBar from '@ui-components/task-details-name-bar';
import { IconType } from '@ui-components/icon-template';

import { Task, Shelf } from '../../common/types';
import history from '../../utils/history';
import { TaskDetailsContent } from '..';
import TaskDetailsRailLeft from '../TaskDetailsRailLeft';
import i18n from '../../i18n';
import TRANSLATE_KEYS from '../../public/locales/translateKeys';

interface Props {
  task: Task;
  setSelectedShelf: (shelfId: string, changeToInspect: boolean) => void;
  selectedShelf: string;
  shelfComponent: ReactNode;
  registeredShelves: {
    [key: string]: {
      icon: IconType;
      menuLabel: string;
      dynamicNavigationLabel: boolean;
    };
  };
  actionButtons: ReactNode;
}

const TaskDetailsBody: FC<Props> = ({
  task,
  setSelectedShelf,
  selectedShelf,
  shelfComponent,
  registeredShelves,
  actionButtons
}) => {
  const scrollContentRef = createRef<HTMLDivElement>();

  useEffect(() => {
    return () => history.replace({ state: { redirectFromTask: true } });
  }, []);

  const handleClickReturn = () => {};

  const shelvesRefs: { [key: string]: RefObject<HTMLDivElement> | null } =
    task.shelves &&
    task.shelves.reduce((acc: { [key: string]: any }, shelf: Shelf) => {
      acc[shelf.id] = createRef<HTMLDivElement>();
      return acc;
    }, {});

  const scrollToShelf = (shelfId: string) => {
    const shelfRef = shelvesRefs[shelfId];

    if (shelfRef && scrollContentRef && scrollContentRef.current && shelfRef.current)
      scrollContentRef.current.scrollTo({
        left: 0,
        top: shelfRef.current.offsetTop,
        behavior: 'smooth'
      });
    setSelectedShelf(shelfId, false);
  };

  const { shelves, name } = task;

  return (
    <TaskDetailsBodyLayout
      nameBar={
        <TaskDetailsNameBar
          label={i18n.t(TRANSLATE_KEYS.task_details_page.task_list_label)}
          name={name}
          handleClickReturn={handleClickReturn}
        >
          {/* TODO solution until we find the way to abstract TaskActionButtons. it is passed here as we do not want ui-components to contain anything outside of it self */}
          {actionButtons}
        </TaskDetailsNameBar>
      }
      content={
        <TaskDetailsContent
          task={task}
          shelvesRefs={shelvesRefs}
          scrollRef={scrollContentRef}
          selectedShelf={selectedShelf}
          setSelectedShelf={setSelectedShelf}
          shelfComponent={shelfComponent}
        />
      }
      leftRail={
        <TaskDetailsRailLeft
          shelves={shelves}
          onRailItemClick={scrollToShelf}
          selectedShelf={selectedShelf}
          registeredShelves={registeredShelves}
        />
      }
    />
  );
};

export default TaskDetailsBody;
